/* eslint-disable */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import {
    UserIcon as SourceUserIcon
} from 'SourceComponent/UserIcon/UserIcon.component';
import PropTypes from 'prop-types';
import './UserIcon.style';

/** @namespace Scandipwa/Component/UserIcon/Component */
export class UserIconComponent extends SourceUserIcon {
    static propTypes = {
        isActive: PropTypes.bool
    };

    static defaultProps = {
        isActive: false
    };

    render() {
        const { isActive } = this.props;

        return (
            <svg block="UserIcon" mods={ { isActive } } width="100%" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M6.56232 6.72C8.54692 6.72 10.1544 5.21636 10.1544 3.36C10.1544 1.50364 8.54692 0 6.56232 0C4.57772 0 2.97021 1.50364 2.97021 3.36C2.97021 5.21636 4.57772 6.72 6.56232 6.72ZM6.56232 1.27273C7.79273 1.27273 8.79378 2.20909 8.79378 3.36C8.79378 4.51091 7.79273 5.44727 6.56232 5.44727C5.33191 5.44727 4.33086 4.51091 4.33086 3.36C4.33086 2.20909 5.33191 1.27273 6.56232 1.27273Z" fill="#D29143"/>
               <path d="M8.10556 7.56543H4.89444C2.19453 7.56543 0 9.61816 0 12.1436V13H1.36065V12.1436C1.36065 10.3218 2.94483 8.83816 4.89444 8.83816H8.10556C10.0532 8.83816 11.6394 10.3218 11.6394 12.1436V13H13V12.1436C13 9.61998 10.8055 7.56543 8.10556 7.56543Z" fill="#D29143"/>
            </svg>
        );
    }
}

export default UserIconComponent;
